import React,{useState,useEffect,useRef} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {navLinks,megaMenu} from '../data/company';
import {Magnetic,fireSpark} from './effects';
import {Menu,X} from 'lucide-react';

export default function Navbar(){
  const [scrolled,setScrolled]=useState(false);
  const [mega,setMega]=useState(false);
  const [sheet,setSheet]=useState(false);
  const [megaLeft,setMegaLeft]=useState(null);
  const loc=useLocation();
  const megaTimer=useRef(null);
  const wrapRef=useRef(null);
  const triggerRef=useRef(null);
  useEffect(()=>{const s=()=>setScrolled(window.scrollY>40);s();window.addEventListener('scroll',s,{passive:true});return()=>window.removeEventListener('scroll',s);},[]);
  useEffect(()=>{setSheet(false);setMega(false);},[loc.pathname]);
  const positionMega=()=>{
    if(!triggerRef.current||!wrapRef.current)return;
    const t=triggerRef.current.getBoundingClientRect();
    const w=wrapRef.current.getBoundingClientRect();
    setMegaLeft(t.left-w.left+t.width/2);
  };
  const openMega=()=>{clearTimeout(megaTimer.current);positionMega();setMega(true);};
  const closeMega=()=>{megaTimer.current=setTimeout(()=>setMega(false),160);};
  return <>
    <div ref={wrapRef} className={`nav-wrap${scrolled?' scrolled':''}`}>
      <nav className={`nav${scrolled?' scrolled':''}`} aria-label="Ana menü">
        <Link to="/" className="nav-logo" aria-label="Plaza Turizm ana sayfa"><img src="/assets/plaza-logo.png" alt="Plaza Turizm" width="399" height="97"/></Link>
        <div className="nav-links">
          {navLinks.map(l=>l.mega?(
            <div key={l.label} ref={triggerRef} onMouseEnter={openMega} onMouseLeave={closeMega} style={{position:'relative'}}>
              {l.to&&l.to!=='#'
                ? <Link to={l.to} className={`nav-link${mega||loc.pathname===l.to?' active':''}`} aria-haspopup="true" aria-expanded={mega}>{l.label}</Link>
                : <button className={`nav-link${mega?' active':''}`} aria-haspopup="true" aria-expanded={mega} onClick={()=>setMega(m=>!m)}>{l.label}</button>}
            </div>
          ):(
            <Link key={l.label} to={l.to} className={`nav-link${loc.pathname===l.to?' active':''}`}>{l.label}</Link>
          ))}
        </div>
        <Link to="/iletisim" className="btn btn-primary nav-cta desk" style={{padding:'12px 22px',fontSize:'15px'}} onClick={(e)=>fireSpark(e.clientX,e.clientY)} data-cursor="go">
          <Magnetic strength={0.25}>İletişime Geç</Magnetic>
        </Link>
        <button className="nav-burger" aria-label="Menü" onClick={()=>setSheet(true)}><Menu size={22}/></button>
      </nav>
      <div className={`mega glass mega-2col${mega?' open':''}`} style={megaLeft!=null?{left:`${megaLeft}px`}:undefined} onMouseEnter={openMega} onMouseLeave={closeMega}>
        {megaMenu.map((col,i)=>(
          <div key={i} className="mega-col">
            {col.title&&<h4>{col.title}</h4>}
            {col.items.map(it=><Link key={it.label} to={it.to}>{it.label}</Link>)}
          </div>
        ))}
      </div>
    </div>
    <div className={`msheet${sheet?' open':''}`}>
      <div className="msheet-top"><img src="/assets/plaza-logo.png" alt="Plaza Turizm" width="399" height="97"/><button className="nav-burger" aria-label="Kapat" onClick={()=>setSheet(false)} style={{display:'flex'}}><X size={22}/></button></div>
      {navLinks.map(l=>l.mega?(
        <React.Fragment key={l.label}>
          <Link to={l.to} className="msheet-parent">{l.label}</Link>
          {megaMenu.flatMap(c=>c.items).map(it=><Link key={it.label} to={it.to} className="msheet-sub">{it.label}</Link>)}
        </React.Fragment>
      ):(
        <Link key={l.label} to={l.to}>{l.label}</Link>
      ))}
      <Link to="/iletisim" className="btn btn-primary" style={{marginTop:24,justifyContent:'center'}}>İletişime Geç</Link>
    </div>
  </>;
}
